// @ts-nocheck
import React, { useEffect, useState } from 'react'
import '../../styles/dashboard.css';
import useAxiosPrivate from '../../api/useAxiosPrivate';
import { useLocation, useParams } from 'react-router-dom';
import { notify } from '../toast';

const AdminHospital = () => {

    const admittedAtOptions = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
    };

    const { id } = useParams();
    const { state } = useLocation();


    const [patients, setPatients] = useState([]);
    const [totalPatients, setTotalPatients] = useState(1);

    const [pageLoading, setPageLoading] = useState(false);

    const axiosPrivate = useAxiosPrivate();

    const fetchPatientsByHospital = async () => {
        try {

            if (totalPatients === patients.length) return notify('info', 'End of list reached')

            setPageLoading(true);

            const response = await axiosPrivate.get(`/admin/getPatientsByHospitals/${id}?page=${Math.ceil(patients.length / 10) + 1}`);

            const data = response?.data
            setPatients(prev => [...prev, ...data?.patients]);
            setTotalPatients(data?.total);

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        } finally {
            setPageLoading(false);
        }
    }

    useEffect(() => {
        fetchPatientsByHospital();

        // eslint-disable-next-line
    }, []);

    return (
        <div className='container'>

            <h2 style={{ margin: '20px 0' }}>
                Patients admitted in <i style={{ color: 'var(--primary-text-color)' }}>{state?.name}</i>
            </h2>

            {// @ts-ignore
                patients?.length !== 0 &&

                <section className="user-list">
                    <div className="list-header">
                        <span>Name</span>
                        <span>Gender</span>
                        <span>Age</span>
                        <span>Mobile</span>
                        <span>Admitted on</span>
                    </div>

                    <div className="list-body">
                        {
                            patients.map((patient) => (
                                <div className="list-row" key={patient?.addedAt}>
                                    <span className='truncate' title={patient?.patient?.name} data-label="Name">{patient?.patient?.name}</span>
                                    <span className='truncate' title={patient?.patient?.gender} data-label="Gender">{patient?.patient?.gender}</span>
                                    <span className='truncate' title={patient?.patient?.age} data-label="Age">{patient?.patient?.age}</span>
                                    <span className='truncate' title={patient?.patient?.mobile} data-label="Mobile">{patient?.patient?.mobile}</span>
                                    <span className='truncate' title={new Date(patient?.addedAt).toLocaleString('en-In', admittedAtOptions)} data-label="Admitted on">{new Date(patient?.addedAt).toLocaleString('en-In', admittedAtOptions)}</span>
                                </div>
                            ))
                        }
                    </div>

                </section>
            }

            {totalPatients !== patients.length ?
                <div>
                    <button className='add-btn' disabled={pageLoading} onClick={fetchPatientsByHospital}>{pageLoading ? <span className='spinner' /> : 'Load more'}</button>
                </div>
                : <></>
            }

        </div>
    )
}

export default AdminHospital
